
import { designersData } from '../../../mocks/designers';

export default function Designers() {
  return (
    <section id="designers" className="py-32 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-light mb-6 tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            Designer Showcase
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Emerging and established voices from across the Caribbean
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {designersData.map((designer, index) => (
            <div key={index} className="group cursor-pointer">
              <div className="relative overflow-hidden mb-6 aspect-[3/4]">
                <img 
                  src={designer.image}
                  alt={designer.name}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300"></div>
              </div>
              <h3 className="text-2xl font-light mb-2 tracking-wide">{designer.name}</h3>
              <p className="text-[#14B8A6] text-sm mb-3 tracking-wide">{designer.origin}</p>
              <p className="text-gray-600 text-sm leading-relaxed">{designer.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
